export const StorageKeys = {
	LAST_ROUTE: 'last_route',
	API_USER_KEY: 'user_key',
} as const;
